module.exports = __webpack_public_path__ + "static/home_img-810d47e007136c035fa70c423f9d4656.png";